import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../elements/Button';
import Image from '../../elements/Image';
import AchImageFlip1 from './AchImageFlip1';
import AchImageFlip2 from './AchImageFlip2';
import PrintImageFlip1 from './PrintImageFlip1';
import PrintImageFlip2 from './PrintImageFlip2';
import MailedImageFlip1 from './MailedImageFlip1';
import MailedImageFlip2 from './MailedImageFlip2';
import RtpImageFlip1 from './RtpImageFlip1';
import RtpImageFlip2 from './RtpImageFlip2';
import InstantImageFlip1 from './InstantImageFlip1';
import InstantImageFlip2 from './InstantImageFlip2';
import VccImageFlip1 from './VccImageFlip1';
import VccImageFlip2 from './VccImageFlip2';

import Point from '../../elements/Point';

import './style.scss';
import ZelleImageFlip1 from './ZelleImageFlip1';
import ZelleImageFlip2 from './ZelleImageFlip2';

function ProductTwoCol(props) {
    const { title, description, points, images, image_id } = props;

    return (
        <div className="product-twocol-container">
            <div className="product-twocol row g-0 align-items-center">
                <div className="text-panel row g-0 col-xl-6">
                    <div className="text-panel-upper col-lg-6 pe-lg-5 col-xl-12">
                        <h2>{title}</h2>
                        <p className="segment-text">{description}</p>
                    </div>
                    {points.map((point, i) => {
                        return (
                            <Point
                                className="point col-md-6 col-lg-3 col-xl-6"
                                image={point.image}
                                header={point.header}
                                text={point.text}
                            />
                        );
                    })}
                </div>
                <div
                    id={image_id}
                    className="image-panel col-xl-6 row g-0 justify-content-center"
                >
                    <div className="flip-container col-12 row g-0 justify-content-around justify-content-xl-center align-items-start">
                        {/* <Image className="col-5 col-xl-12" src={images[0].image} alt="product flow" id="front"/> 
            <Image className="col-5 col-xl-12" src={images[1].image} alt="product flow" id="back"/>  */}

                        {props.page === 'achPayment' && (
                            <>
                                <AchImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <AchImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'instantPayment' && (
                            <>
                                <InstantImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <InstantImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'mailPayment' && (
                            <>
                                <MailedImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <MailedImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'printPayment' && (
                            <>
                                <PrintImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <PrintImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'rtpPayment' && (
                            <>
                                <RtpImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <RtpImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'vccPayment' && (
                            <>
                                <VccImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <VccImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'fednowPayment' && (
                            <>
                                <RtpImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <RtpImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}

                        {props.page === 'zellePayment' && (
                            <>
                                <ZelleImageFlip1
                                    className="col-5 col-xl-12"
                                    src={images[0].image}
                                    alt="product flow"
                                    id="front"
                                />
                                <ZelleImageFlip2
                                    className="col-5 col-xl-12"
                                    src={images[1].image}
                                    alt="product flow"
                                    id="back"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

ProductTwoCol.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    points: PropTypes.array.isRequired,
    image: PropTypes.object.isRequired,
};

export default ProductTwoCol;
